<template>
  <v-menu
    v-model="open"
    :close-on-content-click="false"
    offset-y
    min-width="240"
    rounded="lg"
    content-class="box_menu"
  >
    <template #activator="{ on: onMenu }">
      <v-tooltip bottom>
        <template #activator="{ on: onTooltip }">
          <v-btn v-on="{ ...onMenu, ...onTooltip }" id="AccountMenu" icon @click="$emit('open')">
            <v-icon v-if="isLogged">
              account_circle
            </v-icon>

            <v-icon v-else>
              more_vert
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $tc('my_account') }}</span>
      </v-tooltip>
    </template>

    <template v-if="option === 1">
      <template>
        <v-list-item v-if="isLogged">
          <v-list-item-avatar>
            <v-icon large>
              account_circle
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ username }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="subtitle">
              {{ subtitle }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider v-if="isLogged" />

        <v-list>
          <v-list-item-group v-if="isLogged">
            <v-list-item
              v-for="(item, index) in menuItemsLogged"
              :key="index"
              @click="item.click"
            >
              <v-list-item-icon class="mr-2">
                <v-icon size="16">
                  {{ item.icon }}
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title :id="`AccountMenu_${item.id}`">
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-icon size="16">
                  {{ item.actionIcon }}
                </v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>

          <v-list-item-group v-else>
            <v-list-item
              v-for="(item, index) in menuItemsNotLogged"
              :key="index"
              @click="item.click"
            >
              <v-list-item-icon class="mr-2">
                <v-icon size="16">
                  {{ item.icon }}
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title :id="`AccountMenu_${item.id}`">
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-icon size="16">
                  {{ item.actionIcon }}
                </v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </template>

      <v-card-actions v-if="isLogged">
        <v-spacer />
        <v-btn id="logout" text @click="logout">
          {{ $t('logout') }}
        </v-btn>
      </v-card-actions>
    </template>

    <template v-else-if="option === 2">
      <v-list-item>
        <v-list-item-icon>
          <v-btn id="theme_back" icon @click="closeThemeSelector">
            <v-icon>
              chevron_left
            </v-icon>
          </v-btn>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            {{ $tc('appearance') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          :class="{ 'theme-selected': darkTheme === item }"
          @click="themeSelected(item)"
        >
          <v-list-item-action class="mr-2">
            <v-icon v-if="darkTheme === item" size="16">
              mdi-check
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $tc(item) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>

    <template v-else>
      <v-list-item>
        <v-list-item-icon>
          <v-btn id="locale_back" icon @click="closeLocaleSelector">
            <v-icon>
              chevron_left
            </v-icon>
          </v-btn>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            {{ $tc('language') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list>
        <v-list-item
          v-for="(item, index) in locales"
          :key="index"
          :class="{ 'theme-selected': locale === item }"
          @click="selectLocale(item)"
        >
          <v-list-item-action class="mr-2">
            <v-icon v-if="locale === item" size="16">
              mdi-check
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t(`i18n.${item}`) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-menu>
</template>

<script>

export default {
  emits: ['close', 'open'],
  components: {
  },
  props: {
    username: {
      type: String,
      require: true,
      default: null
    },
    subtitle: {
      type: String,
      require: true,
      default: null
    }
  },
  data () {
    return {
      open: false,
      items: ['system', 'dark', 'light'],
      option: 1
    }
  },
  computed: {
    menuItemsLogged () {
      return [
        {
          click: () => this.openLocaleSelector(),
          icon: 'translate',
          id: 'language',
          title: `${this.$tc('language')}: ${this.$t(`i18n.${this.locale}`)}`,
          actionIcon: 'chevron_right'
        },
        {
          click: () => this.openThemeSelector(),
          icon: 'mode_night',
          id: 'appearance',
          title: this.$tc('appearance'),
          actionIcon: 'chevron_right'
        },
        {
          click: () => this.$router.push({ name: 'profile', query: { tab: 'attributes' } }),
          icon: 'edit_attributes',
          id: 'attributes',
          title: this.$t('attributes'),
          actionIcon: null
        },
        {
          click: () => this.$router.push({ name: 'profile', query: { tab: 'permissions' } }),
          icon: 'checklist_rtl',
          id: 'permissions',
          title: this.$tc('system_permission', 2),
          actionIcon: null
        },
        {
          click: () => this.$router.push({ name: 'profile', query: { tab: 'change-password' } }),
          icon: 'password',
          id: 'change_password',
          title: this.$t('change_password'),
          actionIcon: null
        }
      ]
    },
    menuItemsNotLogged () {
      return [
        {
          click: () => this.openLocaleSelector(),
          icon: 'translate',
          id: 'language',
          title: `${this.$tc('language')}: ${this.$t(`i18n.${this.locale}`)}`,
          actionIcon: 'chevron_right'
        },
        {
          click: () => this.openThemeSelector(),
          icon: 'mode_night',
          id: 'appearance',
          title: this.$tc('appearance'),
          actionIcon: 'chevron_right'
        }
      ]
    },
    darkTheme: {
      get () {
        return this.$store.state.ui.themeMode
      },
      set (val) {
        this.$store.commit('ui/SET_THEME_MODE', val)
      }
    },
    isLogged () {
      return this.$store.state.auth.isLogged
    },
    locale: {
      get () {
        return this.$store.state.locale.locale
      },
      set (val) {
        this.$store.commit('locale/SET_LOCALE', val)
      }
    },
    locales () {
      return this.$store.state.locale.locales
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/doLogout')
      this.open = false
    },
    themeSelected (theme) {
      this.darkTheme = theme
    },
    selectLocale (locale) {
      this.locale = locale
    },
    openThemeSelector () {
      this.option = 2
    },
    openLocaleSelector () {
      this.option = 3
    },
    closeThemeSelector () {
      this.option = 1
    },
    closeLocaleSelector () {
      this.option = 1
    }
  },
  watch: {
    open (val) {
      if (val === false) {
        this.option = 1
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.theme--dark.v-list {
  background: #1e1e1e0a;
}
</style>
